export default __webpack_public_path__ + "static/media/bg03.cf1f762b.jpg";